import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LeaderboardModule } from '@app/leaderboard';

import { ProfileMeLeaderboardComponent } from './leaderboard.component';
import { DataTestModule } from '@app/shared/directive/data-test';
import { AccesibilityModule } from '@app/shared/accesibility/accesibility.module';
import { IconComponent } from '@app/tw-shared/components';

@NgModule({
    imports: [CommonModule, RouterModule, TranslateModule, InlineSVGModule, LeaderboardModule, DataTestModule, AccesibilityModule, IconComponent],
    declarations: [ProfileMeLeaderboardComponent],
    exports: [ProfileMeLeaderboardComponent],
})
export class ProfileMeLeaderboardModule {}
